// src/pages/UnauthorizedPage.tsx
import React from 'react';
import { Container, Typography, Paper, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const UnauthorizedPage: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom color="error">
          Access Denied
        </Typography>
        
        <Typography variant="body1" paragraph>
          You don't have permission to access this page. This area requires administrative privileges.
        </Typography>
        
        <Box sx={{ mt: 4 }}>
          <Button component={Link} to="/" variant="contained" color="primary">
            Return to Home
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default UnauthorizedPage;
